import { MarketingNav } from './MarketingNav';

export type { MarketingNavProps } from './MarketingNav.types';

export default MarketingNav;
